<template>
  <registerSuccess v-if="isRegisterSuccess"></registerSuccess>


  <NuxtLayout name="search-basic-layout"
              v-else>
    <h1 class="text-[32px] text-center">空間便利店 註冊</h1>
    <div class="register-wrap">
      <el-icon :size="25"
               @click="goHome(route.query)"
               class="close-icon cursor-pointer">
        <CloseBold/>
      </el-icon>
      <div class="title">{{ title }}</div>
      <InputField autocomplete="off"
                  :isValid="valid.isNameValid"
                  :placeholder="$t('register.name')"
                  :comment="$t('comment.name')"
                  :alert="$t('error_message.name')"
                  @keyup="handleNameChange"/>
      <InputField :placeholder="$t('placeholder.account')"
                  :isValid="valid.isAccountValid"
                  :alert="errorMessage.accountErrorMessage"
                  :value="info.account"
                  @keyup="handleAccountChange"/>
      <InputField name="register_password"
                  autocomplete="off"
                  maxlength="20"
                  :isValid="valid.isPasswordValid"
                  :placeholder="$t('placeholder.password')"
                  :alert="errorMessage.passwordErrorMessage"
                  :comment="$t('comment.password')"
                  type="password"
                  @keyup="handlePasswordChange"
                  :registerPassword="true"/>
      <InputField autocomplete="off"
                  maxlength="20"
                  :isValid="valid.isPasswordAgainValid"
                  :placeholder="$t('placeholder.password_again')"
                  :alert="$t('error_message.password_again')"
                  type="password"
                  @keyup="handlePasswordAgainChange"
                  :registerPassword="true"/>
      <div class="flex mb-[20px]">
        <InputField placeholder="驗證碼"
                    :isValid="valid.isCaptchaValid"
                    :alert="errorMessage.captchaErrorMessage"
                    maxlength="4"
                    :value="info.captcha"
                    @change="handleCaptchaChange"
                    class=""/>
        <Captcha ref="captchaComp"
                 class="h-[50px] ml-auto"></Captcha>
      </div>
      <div @click="handleRegister"
           class="register-btn">{{ $t('register.register') }}
      </div>
      <div class="go-login">
        <span> {{ $t('register.terms_0') }}</span>
        <a :href="termsUrl"> {{ $t('register.terms_1') }}</a>
      </div>
      <!--    google 登入-->
      <form class="google-form"
            method="post"
            :action="googleLoginUrl">
        <input type="hidden"
               name="redirect_uri"
               class="g-return"
               :value="homeUrl+'google-return'">
        <button type="submit"
                class="login-google">
          <span class="google-logo"></span>
          {{ $t('login.google_login') }}
          <span class="w-[24px]"></span>
        </button>
      </form>
      <div class="go-login">
        <span> {{ $t('register.have_account') }}</span>
        <span @click="go('/login')"> {{ $t('register.go_login') }}</span>
        <img src="../assets/image/icon/svg/arrow_circle_right.svg"
             alt="">

      </div>
    </div>
  </NuxtLayout>


</template>
<script setup>
import {ref, computed, onMounted, provide} from "vue";

import {register} from '@/api/auth'
import {accountRegex, passwordRegex} from '../utils/regex.js'
import {hashPassword} from "@/utils/parseTool.js";
import InputField from '../components/InputField.vue'
import registerSuccess from "@/components/SettingSuccess/RegisterSuccess.vue";

import {CloseBold} from '@element-plus/icons-vue'
import {useI18n} from '#imports';
import {useUserStore} from "@/stores/user";
import {useGoTo} from "@/composables/useGoTo";

import Captcha from "@/components/Captcha/Captcha.vue";

definePageMeta(
    { title: '會員註冊' }
)

const layoutProps = {
  footer: false
};
provide('searchBasicLayoutProps', layoutProps);

const seoMeta = {
  title: '空間便利店 註冊頁面｜方便順利的場地租借平台。時租日租場地，活動聚會場地，商務會議線上預約',
  description: '場地租借要便利，就在空間便利店。一分鐘線上預訂，即時確認，方便又安心。場地租借、活動空間、會議室，各種場地一步搞定',
  ogTitle: '空間便利店 空間文章｜方便順利的場地租借平台。時租日租場地，活動聚會場地，商務會議線上預約',
  ogSiteName: '空間便利店',
  ogDescription: '場地租借要便利，就在空間便利店。一分鐘線上預訂，即時確認，方便又安心。場地租借、活動空間、會議室，各種場地一步搞定',
  ogUrl: 'https://www.onestep.place',
  ogType: 'website',
  ogImage: 'https://pic.onestep.place/images/onestep-og.png',
  ogImageAlt: '空間便利店｜方便順利的場地租借平台。時租日租場地，活動聚會場地，商務會議線上預約'
};

useSeoMeta(seoMeta);



const { $fbq } = useNuxtApp()
const router = useRouter()
const route = useRoute();
const {t} = useI18n();
const userStore = useUserStore()
const {goHome} = useGoTo();
const isLogin = computed(() => userStore.getToken);
const homeUrl = ref(import.meta.env.VITE_APP_BASE_HOME_URL)
const termsUrl = ref(import.meta.env.VITE_APP_BASE_TERMS_URL)
const googleLoginUrl = import.meta.env.VITE_APP_API_URL + '/api/auth/google-login'
const isRegisterSuccess = ref(false)
const captchaComp = ref(null)

const title = ref(t('register.title'))
const info = ref({
  account: '',
  password: '',
  passwordAgain: '',
  name: '',
  captcha: ''
})

const valid = ref({
  isAccountValid: true,
  isPasswordValid: true,
  isPasswordAgainValid: true,
  isNameValid: true,
  isCaptchaValid: true
})

const errorMessage = ref({
  accountErrorMessage: '',
  passwordErrorMessage: '',
  nameErrorMessage: ''
})

const isAllValid = computed(() => {
  return valid.value.isAccountValid && valid.value.isPasswordValid && valid.value.isPasswordAgainValid &&
      valid.value.isNameValid && valid.value.isCaptchaValid;
});


onMounted(() => {
  if (isLogin.value) {
    goHome(route.query)
  } else {
    $fbq('trackCustom', 'OSUserInitialRegister')
  }
})

const handleNameChange = (e) => {
  info.value.name = e.target.value
  valid.value.isNameValid = info.value.name !== ''
}
const handleAccountChange = (e) => {
  info.value.account = e.target.value.trim()
  valid.value.isAccountValid = accountRegex(info.value.account)
  errorMessage.value.accountErrorMessage = t('error_message.account')
}
const handlePasswordChange = (e) => {
  info.value.password = e.target.value.trim()
  valid.value.isPasswordValid = passwordRegex(info.value.password)
  errorMessage.value.passwordErrorMessage = t('error_message.password')
}
const handlePasswordAgainChange = (e) => {
  info.value.passwordAgain = e.target.value.trim()
  valid.value.isPasswordAgainValid = info.value.password === info.value.passwordAgain
}
const handleCaptchaChange = (e) => {
  info.value.captcha = e.target.value.trim()
  valid.value.isCaptchaValid = info.value.captcha.toLowerCase() === captchaComp.value.captcha.toLowerCase()
  errorMessage.value.captchaErrorMessage = t('error_message.captcha')
}
const handleRegister = async () => {
  handleAccountChange({target: {value: info.value.account}});
  handlePasswordChange({target: {value: info.value.password}});
  handlePasswordAgainChange({target: {value: info.value.passwordAgain}});
  handleNameChange({target: {value: info.value.name}});
  handleCaptchaChange({target: {value: info.value.captcha}})
  if (!isAllValid.value) {
    return
  }

  try {
    const res = await register(info.value.account,hashPassword(info.value.password),info.value.name)

    userStore.updateToken(res.token);
    await userStore.updateUserInfo()
    await router.push({path: '/phone-validation'})

    $fbq('trackCustom', 'OSUserSectionOneRegister')
    $fbq('trackCustom', 'OSUserRegister')


  } catch (error) {
    console.log(error)
  }
}

const go = (url) => {
  router.push({path: url, query: route.query})
}
</script>
<style scoped
       lang="scss">
.register-wrap {
  @apply w-full mt-[18px] mx-[auto] px-[30px] relative
  md:w-[500px] md:mt-[34px];
  .close-icon {
    @apply absolute top-[2px] right-[20px];
  }

  .title {
    @apply text-[20px] text-center mb-[30px];
  }

  > div {
    @apply mb-[20px] h-full;
  }

  .register-btn {
    @apply border mt-[60px] mb-[12px] rounded-full text-center bg-osn-yellow-00 text-[16px] font-semibold h-[50px] leading-[50px] cursor-pointer;
  }

  .login-google {
    @apply w-full h-[50px] leading-[50px] flex justify-between items-center
    text-[16px] bg-white rounded-full border border-black font-medium px-[12px] mb-[20px];
    .google-logo {
      @apply w-[24px] h-[24px] bg-contain;
      background-image: url("../assets/image/icon/gooleLogo.svg");
    }
  }

  .go-login {
    @apply flex text-[16px] justify-center;
    span:nth-child(2) {
      @apply underline underline-offset-2 font-semibold cursor-pointer;
    }
  }
}

</style>
